import axios from "@/api/axiosInstance";
import {
  DataEnvelope,
  Enrollment,
} from "@/modules/learningCenter/features/CourseDirectory/types/viewer";

// Unenroll (cancel) the caller's own enrollment. Progress is preserved so the
// learner can re-enroll later.
export const unenrollCourse = async (
  enrollmentUuid: string,
): Promise<Enrollment> => {
  const response = await axios.delete<DataEnvelope<Enrollment>>(
    `/api/private/learning-center/enrollments/${enrollmentUuid}`,
  );
  return response.data.data;
};
